import { render, staticRenderFns } from "./shopModule.vue?vue&type=template&id=0a55335c&scoped=true&"
import script from "./shopModule.vue?vue&type=script&lang=js&"
export * from "./shopModule.vue?vue&type=script&lang=js&"
import style0 from "./shopModule.vue?vue&type=style&index=0&id=0a55335c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a55335c",
  null
  
)

export default component.exports